import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n'; // 导入 i18n 配置
import Router from './router';
import { BreakdownDataCacheProvider } from './contexts/BreakdownDataCacheContext';
import { UserPermissionsProvider } from './contexts/UserPermissionsContext';
import { FilmProvider } from './contexts/FilmContext';
import { AppTypeProvider } from './contexts/AppTypeContext';
import { CurrentUserProvider } from './contexts/CurrentUserContext';
import { GlobalUsersProvider } from './contexts/GlobalUsersContext';
import { ThemeProvider } from './contexts/ThemeContext';

// 检测操作系统并设置字体
const detectOSAndSetFont = () => {
  const platform = navigator.platform.toLowerCase();
  const userAgent = navigator.userAgent.toLowerCase();
  const isMac = platform.includes('mac') || userAgent.includes('mac');
  const isWindows = platform.includes('win') || userAgent.includes('windows');
  
  if (isMac) {
    document.documentElement.style.setProperty('--app-font-family', "'PingFang SC', 'PingFang TC', -apple-system, BlinkMacSystemFont, sans-serif");
  } else if (isWindows) {
    document.documentElement.style.setProperty('--app-font-family', "'Microsoft YaHei', 'Microsoft JhengHei', 'Segoe UI', sans-serif");
  } else {
    // 其他系统使用默认字体
    document.documentElement.style.setProperty('--app-font-family', "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif");
  }
};

// 在应用启动时设置字体
detectOSAndSetFont();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <AppTypeProvider>
      <CurrentUserProvider>
        <GlobalUsersProvider>
            <ThemeProvider>
            <BreakdownDataCacheProvider>
              <UserPermissionsProvider>
                <FilmProvider>
                  <Router />
                </FilmProvider>
              </UserPermissionsProvider>
            </BreakdownDataCacheProvider>
            </ThemeProvider>
        </GlobalUsersProvider>
      </CurrentUserProvider>
    </AppTypeProvider>
  </React.StrictMode>
); 